
import { defineComponent } from 'vue';
import {
    PhBroadcast,
    PhBuildings,
    PhChalkboardTeacher,
    PhEnvelopeOpen,
    PhLock,
    PhPaperPlaneTilt,
    PhSiren
} from '@phosphor-icons/vue';

export default defineComponent({
    name: 'WizardVisual',
    components: {
        PhBroadcast,
        PhBuildings,
        PhChalkboardTeacher,
        PhEnvelopeOpen,
        PhLock,
        PhPaperPlaneTilt,
        PhSiren
    },
    props: {
        screen: { type: String, required: true },
        branded: { type: Boolean, default: false }
    },
    data() {
        return {
            logoLight: require('../../../assets/images/signup-v2/ditto-mark-white.svg'),
            customBg: require('../../../assets/images/signup-v2/custom-ditto-bg.jpg'),
            strideLogo: require('../../../assets/images/signup-v2/strideux-logo.svg')
        };
    }
});
